// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TQI_","label":"styles_label__2Njb6"};